import { render } from "./Add.vue?vue&type=template&id=0ae05398&scoped=true&ts=true"
import script from "./Add.vue?vue&type=script&lang=ts"
export * from "./Add.vue?vue&type=script&lang=ts"

import "./Add.vue?vue&type=style&index=0&id=0ae05398&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ae05398"]])

export default __exports__